import { gql } from "@apollo/client";

const stopGQL = gql`
  query($loc_id: String!) {
    locations(locID: $loc_id) {
      loc_id
      name
      stops {
        stopid
        title
        photos {
          id
          title
          description
          smallurl
          url
          smallurl
          mediumurl
          largeurl
          mediaType
          network
          username
          priority
        }
        # supplemental videos
        videos {
          id
          title
          type
          mediaType
          playback_type
          projection
          description
          category
          priority
          duration
          smallurl
          smallurl
          mediumurl
          largeurl
          projectionPriority
          url
          videoid
          network
          username
        }
        # supplemental panoramas
        panoramas {
          id
          title
          description
          category
          priority
          start_lat
          start_lon
          hasEasy
          exit_lat
          exit_lon
          start_fov
          thumburl
          smallurl
          smallurl
          mediumurl
          largeurl
          path
          mediaType
        }
      }
    }
  }
`;

export default stopGQL;
